export default "<p>list-gains-nature works!</p>\n"